import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import VerdictBadge from "@/components/VerdictBadge";
import { deskFor } from "@/lib/deskAccents";

export default function Category() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const title = slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  const accent = deskFor(title);

  useEffect(() => {
    setLoading(true);
    api
      .get(`/public/content`, { params: { category: title } })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [slug, title]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <title>{`${title} | Be-Apuo Media Intelligence`}</title>
      <div className={`label-caps ${accent.eyebrow}`}>Section</div>
      <h1 className="mt-2 font-editorial font-black text-4xl sm:text-5xl tracking-tight text-ink">{title}</h1>
      <div className={`mt-10 border-t-2 ${accent.topBorder} pt-8`}>
        {loading ? (
          <p className="text-ink/55">Loading…</p>
        ) : items.length === 0 ? (
          <div className="border border-ink/10 bg-mist p-12 text-center">
            <p className="text-ink/60">No published stories in this section yet.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12">
            {items.map((item) => (
              <Link
                key={item.id}
                to={`/${item.type.replace("_", "-")}/${item.slug}`}
                data-testid={`category-card-${item.slug}`}
                className={`group block border-t-2 ${accent.topBorder} pt-4`}
              >
                <div className="flex items-center gap-2">
                  <span className="label-caps text-ink/55">{item.label}</span>
                  {item.verdict && <VerdictBadge verdict={item.verdict} />}
                </div>
                <h4 className="mt-3 font-editorial font-bold text-xl leading-snug text-ink group-hover:underline decoration-2 underline-offset-4">
                  {item.title}
                </h4>
                <p className="mt-2 text-sm text-ink/70 line-clamp-3">{item.summary}</p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
